import axios from 'axios'
import ErrorCodes from '../enums/ErrorCodes'

const apiURL = process.env.REACT_APP_API_URL;

async function DoAPICall(params){

    let response
    try {
        
        let callOptions={...params.requestOptions};
        
        if(params.userToken){
            callOptions={
                            ...callOptions,
                            headers:{
                                Authorization: "Bearer " + params.userToken
                            }
                        };
        }
        
        switch (params.httpMethod) {
            case 'get':
                response = await axios.get(apiURL+params.uri,callOptions)
                break;
            case 'post':
                response = await axios.post(apiURL+params.uri,params.payLoad,callOptions)
                break;
            case 'put':
                response = await axios.put(apiURL+params.uri,params.payLoad,callOptions)
                break;
            case 'delete':
                response = await axios.delete(apiURL+params.uri,callOptions)
                break;
            default:
                response = await axios.get(apiURL+params.uri,callOptions)
                break;
        }
    } catch (error) {
        let errorMsg='';
        if(error.response){
            error.response.status===401? errorMsg = ErrorCodes.ERROR_401 : errorMsg = ErrorCodes.ERROR_500;
        }else{
            errorMsg = ErrorCodes.ERROR_999
        }
        throw Error(errorMsg);
    }

    return response.data;

}

export default DoAPICall;